import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import FromFieldText from '../../atoms/FromFieldText';
import {getERAssignmentData, getLastERAssignmentNo,} from '../../services/user.service';
import * as CryptoJS from "crypto-js";
import FromFieldDate from "../../atoms/FromFieldDate";
import FromSpFieldTextArea from "../../atoms/FromSpFieldTextArea";
import FromSpFieldTextAreaHari from "../../atoms/FromSpFieldTextAreaHari";
import {getPendingER, getRepairsName} from '../../services/flagging.service';

import AWS from 'aws-sdk';
// Configure AWS with your credentials
AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
    region: process.env.REACT_APP_AWS_BUCKET_REGION,
});
const s3 = new AWS.S3();

const TEXT_REGEX = /^[a-zA-Z0-9-_ ]{1,255}$/;
const Email_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

function ViewERAssignment() {
    const [activeTab, setActiveTab] = useState(0);
    const [validName, setValidName] = useState(true);
    const [loading, setLoading] = useState(true);
    const [listOptions1, setListData1] = useState([]);
    const [foundAssets, setFoundAssets] = useState();
    const [oldfoundAssets, setOldFoundAssets] = useState([]);
    const [name, setName] = useState('');

    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    const [selectedRepairs, setSelectedRepairs] = useState([]);
    const [ErrSelectedRepairs, setErrSelectedRepairs] = useState('');
    const [error, setError] = useState(false);

    const [assignedDate, setAssignedDate] = useState('');
    const [ErrAssignedDate, setErrAssignedDate] = useState('');

    const [returnDate, setReturnDate] = useState('');
    const [ErrReturnDate, setErrReturnDate] = useState('');

    const [servicesList, setServicesList] = useState('');
    const [ErrServicesList, setErrServicesList] = useState('');

    const [serviceProviderAddress, setServiceProviderAddress] = useState('');
    const [ErrServiceProviderAddress, setErrServiceProviderAddress] = useState('');

    const [endUserName, setEndUserName] = useState('');
    const [ErrEndUserName, setErrEndUserName] = useState('');

    const [serviceProviderName, setServiceProviderName] = useState('');
    const [ErrServiceProviderName, setErrServiceProviderName] = useState('');

    const [contactPersonName, setContactPersonName] = useState('');
    const [ErrContactPersonName, setErrContactPersonName] = useState('');

    const [contactNumber, setContactNumber] = useState('');
    const [ErrContactNumber, setErrContactNumber] = useState('');

    const [descriptions, setDescription] = useState('');
    const [ErrDescription, setErrDescription] = useState('');

    const [endUserEmailID, setEndUserEmailID] = useState('');
    const [ErrEndUserEmailID, setErrEndUserEmailID] = useState('');

    const [userEmailID, setUserEmailID] = useState('');
    const [ErrUserEmailID, setErrUserEmailID] = useState('');

    const [userMobileNo, setUserMobileNo] = useState('');
    const [ErrUserMobileNo, setErrUserMobileNo] = useState('');

    const [assignmentNumber, setAssignmentNumber] = useState('');
    const [ErrAssignmentNumber, setErrAssignmentNumber] = useState('');

    const [detailProblem, setDetailProblem] = useState('');
    const [ErrDetailProblem, setErrDetailProblem] = useState('');

    const [uploadFile, setUploadFile] = useState('');
    const [uploadFileError, setUploadFileError] = useState('');

    const [uploadScreenShot, setUploadScrrenShot] = useState('');
    const [uploadScrrenShotError, setUploadScrrenShotError] = useState('');

    const [repairedIssue, setRepairedIssue] = useState('');
    const [ErrRepairedIssue, setErrRepairedIssue] = useState(false);

    const [accidentalDamage, setAccidentalDamage] = useState('');
    const [ErrAccidentalDamage, setErrAccidentalDamage] = useState(false);

    const [amcCovered, setAmcCovered] = useState('');
    const [ErrAmcCovered, setErrAmcCovered] = useState(false);

    const [showTextField, setShowTextField] = useState(false);
    const [additionalInfo, setAdditionalInfo] = useState('');
    const [ErrAdditionalInfo, setErrAdditionalInfo] = useState('');
    const [equipmentList, setEquipmentList] = useState([]);

    const [repairs, setRepairs] = useState([]);

    let encryptedAssignmentNO = CryptoJS.AES.encrypt(
        JSON.stringify({'assignment_no': assignmentNumber}),
        process.env.REACT_APP_ENCRYPT_SECRET_KEY
    ).toString();

    const resetUserInfo = () => {
        setAssignedDate('');
        setServiceProviderName('');
        setEndUserName('');
        setUserEmailID('');
        setSelectedRepairs('');
        setServicesList('');
        setDescription('');
        setUserEmailID('');
        setAssignmentNumber('');
        setDetailProblem('');
        setRepairedIssue('');
        setAccidentalDamage('');
        setAmcCovered('');
        setShowTextField('');
        setAdditionalInfo('');
        setEndUserEmailID('');
        setServiceProviderAddress('');
        setContactNumber('');
        setUserMobileNo('');
        setReturnDate('');
        setContactPersonName('');

    };

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Assignment_no = query.get('assignment_no');

    useEffect(() => {
        if (Assignment_no !== '' && Assignment_no !== null) {
            const decryptedBytes = CryptoJS.AES.decrypt(Assignment_no.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            // Convert the decrypted bytes to a string
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            const decryptCommentId = decrypt_data.assignment_no;
            getAssignmentInfo(decryptCommentId); // get comment info
        }
    }, [])

    const getAssignmentInfo = function (decryptCommentId) {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'assignment_no': decryptCommentId},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData1 = {'token': EncryptData}
        getERAssignmentData(oData1).then(function (res) {
            //console.log("Response Data:", res); // Debugging

            if (Array.isArray(res?.data?.data) && res.data.data.length > 0) {
                var aInfo = res.data.data[0]; // Access the first object
                var aInfo1 = res.data.equipment; // Stores equipment list

                //console.log("aInfo:", aInfo);
                //console.log("aInfo1:", aInfo1);

                setAssignmentNumber(aInfo.erassignment_no);
                setAssignedDate(new Date(aInfo.assignedDate));
                setEndUserEmailID(aInfo.endUser_emailId);
                setEndUserName(aInfo.endUser_name);
                setSelectedRepairs(aInfo.repairs);
                setRepairedIssue(aInfo.equipment_listed_repairs);
                setAccidentalDamage(aInfo.issue_caused);
                setAmcCovered(aInfo.under_warrenty);
                setAdditionalInfo(aInfo.under_warrenty_details);
                setDetailProblem(aInfo.problem_details);
                setServiceProviderName(aInfo.provider_name);
                setServiceProviderAddress(aInfo.provider_address);
                setContactPersonName(aInfo.contact_person);
                setContactNumber(aInfo.contact_no);
                setUserEmailID(aInfo.contact_email);
                setUserMobileNo(aInfo.mobile_no);
                setServicesList(aInfo.service_name);
                setReturnDate(new Date(aInfo.return_date));

                setEquipmentList(aInfo1);
                setActiveTab(1);
            } else {
                //console.log("Error: res.data.data is not an array or is empty");
                setErrMsg("Assignment no Not Found");
            }
        });
    }

    useEffect(() => {
        const fetchData = async () => {

            try {
                let IrEncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                    'param_data': {'new_ownership_id': sessionStorage.getItem('LoggedInDepartmentId')},
                    'authToken': sessionStorage.getItem('LoggedInToken'),
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                let oIrData = {'token': IrEncryptData};

                getPendingER(oIrData).then((res) => {
                    if (res?.data?.data?.length) {
                        setFoundAssets(res.data.data);
                        setOldFoundAssets(res.data.data); // Correctly updating oldFoundAssets
                    }
                    setLoading(false);
                });

                const EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                    'authToken': sessionStorage.getItem('LoggedInToken'),
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                const oData = {'token': EncryptData};

                // Fetch Repairs List Dynamically
                getRepairsName(oData).then((res) => {
                    if (res?.data?.data?.length) {
                        setRepairs(res.data.data.map(item => item.repair_name)); // Update state
                    }
                });

            } catch (error) {
                console.error("Error fetching company profile list: ", error);
            }

        };

        fetchData();
    }, []);

    const handleServices = (e) => {
        setServicesList(e.target.value);
    };


    const handleRepairedIssue = (e) => {
        setRepairedIssue(e.target.value);
    }
    const handleAccidentalDamage = (e) => {
        setAccidentalDamage(e.target.value);
    }
    const handleAMC = (event) => {
        const value = event.target.value;
        setAmcCovered(value);

        // Show text field only if "Yes" is selected
        setShowTextField(value === "Yes");
    };

    const handleNextClick = () => {
        // Handle the "Next" button click to move to the next tab
        setActiveTab(activeTab + 1);
    };

    const handleDescriptionChange = (index, value) => {
        const newDescriptions = [...descriptions];
        newDescriptions[index] = value;
        setDescription(newDescriptions);
    };

    const navigate = useNavigate(); //useNavigate inside component

    const handleBackClick = () => {
        navigate(-1); // Go back to the previous page
    };


    return (
        <div className="container">
            <div className="row">
                <div className="col-6">
                    <h5>View ER Assignment</h5>
                </div>
                <div className="invalid-feedback" role="alert">
                    <i className="fa fa-info-circle"></i>
                    Please Fill all mandatory fields.
                </div>

                {success ? (
                    <div className="alert alert-success" role="alert">
                        <i className="bi bi-check-circle-fill"></i>{success}
                    </div>
                ) : (
                    errMsg && (
                        <div className="alert alert-danger" role="alert">
                            <i className="bi bi-exclamation-triangle-fill"></i>{errMsg}
                        </div>
                    )
                )}
            </div>

            <div className="row">
                <div className="col-6">
                    <h5>&nbsp;</h5>
                </div>
                <div className="col-5 text-right">
                    <button onClick={handleBackClick} className="btn btn-secondary btn-sm ms-3">
                        Back
                    </button>
                    <a href={`/create-new-er-assignment?assignment_no=${encodeURIComponent(encryptedAssignmentNO)}`}>
                        <button type="button" className="btn btn-danger btn-sm ms-3">
                            Edit Assignment
                        </button>
                    </a>
                </div>
            </div>

            <div className="row mt-2">

                <div className='col-md-6'>
                    <FromFieldDate
                        disabled={true}
                        label="Assigned Date" star="*" placeholder="YYYY-MM-DD"
                        inputValue={assignedDate}
                        setInputValue={setAssignedDate}
                        setErrorMsg={ErrAssignedDate}
                    />
                </div>
                <div className="col-6">
                    <FromFieldText
                        readOnly={true}
                        star="*"
                        label="Assignment Number"
                        inputValue={assignmentNumber}
                        setInputValue={setAssignmentNumber}
                        setErrorMsg={setErrAssignmentNumber}
                        errorMsg={ErrAssignmentNumber}
                    />
                </div>
            </div>

            <div className="row mt-2">

                <div className='col-md-6'>
                    <FromFieldText readOnly={true}
                                   star="*"
                                   label="End User Email ID"
                                   placeholder="End User Email ID"
                                   inputValue={endUserEmailID}
                                   setInputValue={setEndUserEmailID}
                                   setErrorMsg={ErrEndUserEmailID}
                    />
                </div>
                <div className="col-6">
                    <FromFieldText readOnly={true}
                                   star="*"
                                   label="End User Name"
                                   placeholder="End User Name"
                                   inputValue={endUserName}
                                   setInputValue={setEndUserName}
                                   setErrorMsg={ErrEndUserName}
                    />
                </div>
            </div>

            <div className="row mt-3">
                <h6 className="text-center">List of Equipment</h6>
                <table className="table table-bordered equipment-table">
                    <thead className="text-center">
                    <tr>
                        <th>Sl #</th>
                        <th>TAG No</th>
                        <th>TAG Name</th>
                        <th>Item Description</th>
                    </tr>
                    </thead>
                    <tbody className="text-center">
                    {listOptions1 && listOptions1.length > 0 ? (
                        listOptions1.map((option, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{option.label}</td>
                                <td>TAG NAME</td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={`itemDescription[${index}]`}
                                        placeholder="Description"
                                        value={descriptions[index] || ''}
                                        onChange={(e) => handleDescriptionChange(index, e.target.value)}
                                    />
                                    {ErrDescription[index] && (
                                        <span className="error-message">{ErrDescription[index]}</span>
                                    )}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td>No Data</td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>

            <div className="p-3">
                <label><strong>Please Select the Repairs<span className="error">*</span></strong></label>
                <div className="row">
                    {repairs.map((repair, index) => (
                        <div className="col-sm-2 mb-1" key={index}>
                            <div className="form-check">
                                <input disabled={true}
                                       className="form-check-input"
                                       type="checkbox"
                                       id={`repair-${index}`}
                                       checked={selectedRepairs.includes(repair)}
                                />
                                <label className="form-check-label" htmlFor={`repair-${index}`}>
                                    {repair}
                                </label>
                            </div>
                        </div>
                    ))}
                </div>
                {ErrSelectedRepairs && (
                    <div className="text-danger">{ErrSelectedRepairs}</div>
                )}
            </div>

            <div className="row mt-3">
                <div className="col-md-6">
                    <label> Was the equipment listed above been repaired for the same issue? <span
                        className="error">*</span></label>
                    <span className="star error">  </span>
                </div>
                <div className="col-md-3">
                    <select onChange={handleRepairedIssue} disabled name="alternative_verification"
                            className="form-select form-select-sm">
                        <option value="">Select Repaired Issue</option>
                        <option value="Yes"
                                selected={repairedIssue === "Yes" ? "selected" : ''}>Yes
                        </option>
                        <option value="No"
                                selected={repairedIssue === "No" ? "selected" : ''}>No
                        </option>
                    </select>
                    <span className="invalid-feedback">{ErrRepairedIssue} </span>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-md-6">
                    <label> Was the issue caused by accidental damage like water spill, equipment was
                        dropped?<span className="error">*</span></label>
                    <span className="star error">  </span>
                </div>
                <div className="col-md-3">
                    <select onChange={handleAccidentalDamage} disabled name="alternative_verification"
                            className="form-select form-select-sm">
                        <option value="">Select Accidental Damage</option>
                        <option value="Yes"
                                selected={accidentalDamage === "Yes" ? "selected" : ''}>Yes
                        </option>
                        <option value="No"
                                selected={accidentalDamage === "No" ? "selected" : ''}>No
                        </option>
                    </select>
                    <span className="invalid-feedback">{ErrAccidentalDamage} </span>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-md-6">
                    <label>Is asset covered under warranty/AMC/Insurance?<span
                        className="error">*</span></label>
                    <span className="star error"></span>
                </div>
                <div className="col-md-3">
                    <select onChange={handleAMC} name="amcCovered" disabled className="form-select form-select-sm">
                        <option value="">Select Accidental Damage</option>
                        <option value="Yes" selected={amcCovered === "Yes"}>Yes</option>
                        <option value="No" selected={amcCovered === "No"}>No</option>
                    </select>
                    <span className="invalid-feedback">{ErrAmcCovered}</span>
                </div>
            </div>

            {/* Additional Information div */}
            {showTextField && (
                <div className="row mt-3">
                    <div className="col-md-6">
                        <label>Additional Information<span className="error">*</span></label>
                    </div>
                    <div className="col-md-6">
                        <FromSpFieldTextAreaHari readOnly
                                                 maxLength={2000}
                                                 numRows={5}
                                                 className="form-control"
                                                 inputValue={additionalInfo}
                                                 setInputValue={setAdditionalInfo}
                                                 onChange={(e) => setAdditionalInfo(e.target.value)}
                                                 errorMsg={ErrAdditionalInfo}
                        />
                        <span className="invalid-feedback">{ErrAdditionalInfo}</span>
                    </div>
                </div>
            )}
            <div className="row mt-3">
                <div className="col-md-6">
                    <label>Brief description of the problem<span className="error">*</span></label>
                </div>
                <div className='col-md-6'>
                    <FromSpFieldTextAreaHari maxLength="2000" numRows="5" readOnly
                                             inputValue={detailProblem}
                                             setInputValue={setDetailProblem}
                                             setErrorMsg={ErrDetailProblem}
                    />
                </div>
                <div className="row mt-3">
                    <div className="col-md-12">
                        <label>Upload Files of the Problem (if applicable)</label>
                        <br/>
                        <small className="form-text text-muted">Only JPEG, PNG, and PDF files are allowed.
                            Maximum
                            size: 5 MB. Maximum 5 files allowed at
                            once. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</small>
                        <input type="file" name="uploadFile" multiple/>
                        <span className="invalid-feedback">{uploadFileError}</span>
                    </div>


                    <div className="col-md-12 mt-3">
                        <label>Upload Screenshots of the Problem (if
                            applicable) &nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <br/>
                        <small className="form-text text-muted">Only JPEG, PNG, and PDF files are allowed.
                            Maximum
                            size: 5 MB. Maximum 5 files allowed
                            once.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</small>
                        <input type="file" name='uploadScreenshot' multiple/>
                        <span className="invalid-feedback"> {uploadScrrenShotError} </span>
                    </div>

                </div>
            </div>

            <div className="row mt-3">
                <div className="col-md-12">

                </div>

            </div>

            <div className="row mt-3">
                <div className="col-6">
                    <label>Assignment given to:</label>
                </div>
                <div className="col-6">
                    <label></label>
                </div>
            </div>

            <div className="row mt-2">

                <div className='col-md-6'>
                    <FromFieldText
                        star="*" readOnly
                        label="Service Provider Name"
                        placeholder="Service Provider Name"
                        inputValue={serviceProviderName}
                        setInputValue={setServiceProviderName}
                        setErrorMsg={ErrServiceProviderName}
                    />
                </div>
                <div className="col-6">
                    <FromSpFieldTextArea readOnly
                                         numRows="3"
                                         maxLength="200"
                                         star="*"
                                         label="Service Provider Address"
                                         placeholder="Service Provider Address"
                                         inputValue={serviceProviderAddress}
                                         setInputValue={setServiceProviderAddress}
                                         setErrorMsg={ErrServiceProviderAddress}
                    />
                </div>
            </div>


            <div className="row mt-2">

                <div className='col-md-6'>
                    <FromFieldText readOnly
                                   star="*"
                                   label="Contact Person Name"
                                   placeholder="Contact Person Name"
                                   inputValue={contactPersonName}
                                   setInputValue={setContactPersonName}
                                   setErrorMsg={ErrContactPersonName}
                    />
                </div>
                <div className="col-6">
                    <FromFieldText readOnly
                                   star="*"
                                   label="Contact Number"
                                   placeholder="Contact Number"
                                   inputValue={contactNumber}
                                   setInputValue={setContactNumber}
                                   setErrorMsg={ErrContactNumber}
                    />
                </div>
            </div>

            <div className="row mt-2">

                <div className='col-md-6'>
                    <FromFieldText readOnly
                                   star="*"
                                   label="Email Id"
                                   placeholder="Email ID"
                                   inputValue={userEmailID}
                                   setInputValue={setUserEmailID}
                                   setErrorMsg={ErrUserEmailID}
                    />
                </div>
                <div className="col-6">
                    <FromFieldText readOnly
                                   star="*"
                                   label="Mobile Number"
                                   placeholder="Mobile Number"
                                   inputValue={userMobileNo}
                                   setInputValue={setUserMobileNo}
                                   setErrorMsg={ErrUserMobileNo}
                    />
                </div>
            </div>

            <div className="row mt-2">
                <div className="col-md-3">
                    <label>Service under </label><span className="star error"> *</span>
                </div>
                <div className='col-md-3'>
                    <select disabled className="form-select form-select-sm" onChange={handleServices}
                            value={servicesList}>
                        <option value="">Select Service under</option>
                        <option value="Warranty">Warranty</option>
                        <option value="AMC_Coverage">AMC Coverage</option>
                        <option value="Commercial">Commercial</option>
                        <option value="Free_of_Cost">Free of Cost</option>
                        <option value="Not_Applicable">Not Applicable</option>
                        <option value="Others">Others</option>
                    </select>
                    <span className="invalid-feedback"> {ErrServicesList} </span>
                </div>

                <div className="col-6">
                    <FromFieldDate disabled={true}
                                   label="Expected Date of Return" star="*" placeholder="YYYY-MM-DD"
                                   inputValue={returnDate}
                                   setInputValue={setReturnDate}
                                   setErrorMsg={ErrReturnDate}
                    />
                </div>
            </div>


        </div>
    );
}

export default ViewERAssignment;